import React, { useEffect } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { getJobRequest, jobDetailReset } from "../../reducers/job/jobs.reducer";
import JobDetailHeader from "./components/JobDetailHeader";
import NotFoundPage from "../../components/ErrorPages/NotFound";
import { Skeleton } from "@material-ui/lab";
import { rootReducersState } from "../../reducers";
import appRoutes from "../../routes/app.routes";
import { useParams } from "react-router-dom";
import SimilarJobs from "../../components/Jobs/SimilarJobs";
import { Box } from "@material-ui/core";

function JobDetail() {
  const { slug } = useParams();
  const jobApplicationsLoading = useSelector((state: rootReducersState) =>
    _.get(state, "candidate.candidates.jobApplications.loading", false)
  );
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const token = _.get(sessionReducer, "token", "");
  const dispatch = useDispatch();
  const {
    jobs: { detailLoading, detail },
  } = useSelector(({ job }: rootReducersState) => job);

  useEffect(() => {
    dispatch(getJobRequest({ jobSlug: slug, isPublic: true }));
    // On umount reset job detail
    return () => {
      dispatch(jobDetailReset());
    };
  }, [dispatch, slug]);

  if (_.isEmpty(detail) && !detailLoading)
    return <NotFoundPage redirectTo={appRoutes.candidateJobSearch.path} />;

  return (
    <Box className="max-container">
      <Box className={`job-detail-wrapper ${!token ? "no-token" : ""}`}>
        <Box className={`job-detail-content ${!token ? "no-token" : ""}`}>
          <JobDetailHeader
            loading={detailLoading || jobApplicationsLoading}
            {...detail}
            token={token}
            slug={slug}
          />
          <Box component="span" className="separator separator-pink" />
          <Box>
            {detailLoading || jobApplicationsLoading ? (
              <Box className="loading">
                <Skeleton variant="text" width="100%" />
                <Skeleton variant="text" width="80%" />
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="40%" />
                <Skeleton variant="text" width="20%" />
              </Box>
            ) : (
              <Box
                className="wysiwyg-data"
                dangerouslySetInnerHTML={{
                  __html: _.get(detail, "description", ""),
                }}
              />
            )}
          </Box>
        </Box>
        {token && <SimilarJobs token={token} />}
      </Box>
    </Box>
  );
}

export default JobDetail;
